export class ProxyEndPoints {
  static readonly proxyPath = '/proxy';
  static readonly checkAdmin = '/api/checkAdmin';
  static readonly profile = '/api/profile';
  static readonly pathFileUpload = '/api/upload';
  static readonly pathFileUploadLabels = '/api/labels/upload';
  static readonly pathLanguages = '/api/getLanguages';
  static readonly pathTranslate = '/api/translate';
  static readonly pathGetLanguages = '/api/getLocales';
  static readonly downloadTranslatedFile = '/api/downloadTranslatedFile';
  static readonly downloadDTPTranslatedFile = '/api/downloadDTPTranslatedFile';
  static readonly batchJob = '/api/batchJob';
  static readonly getJobStatus = '/api/getJobStatus';
  static readonly getTranslatedDocumentsList = '/api/documents/list';
  static readonly getReviewers = '/api/getreviewers';
  static readonly unacknowledgedCount = '/api/documents/unacknowledged/count?showList=true';
  static readonly unacknowledgedRefresh = '/api/documents/unacknowledged/refresh';
  static readonly analyticsEvent = '/api/event';
  static readonly translationEngine = '/api/instantDocumentProviders';
  static readonly docLangPairRules = '/api/docLangPairRules';
  static readonly listMLProviders = '/api/listMLProviders';
  static readonly listMRProviders = '/api/manualReviewProviders';
  static readonly listVendorProviders = '/api/vendorProviders';
  static readonly listMLProviderPairs = '/api/langPairProviders';
  static readonly languageProvider = '/api/languageProvider';
  static readonly languageProviders = '/api/languageProviders';
  static readonly defaultLangProvider = '/api/defaultLangProvider';
  static readonly deleteLanguagePair = '/api/deleteLangPair';
  static readonly listDisclaimers = '/api/disclaimers';
  static readonly addDisclaimer = '/api/disclaimer';
  static readonly deleteDisclaimer = '/api/deleteDisclaimer';
  static readonly deleteDocument = '/api/deleteDocument';
  static readonly canadianFormTherapeuticAreas =
    '/api/dictionary/canadian/canadian-form-therapeutic-area/values';
  static readonly canadianFormProducts =
    '/api/dictionary/canadian/canadian-form-product/values';
  static readonly vendorOrders = '/api/vendor-orders';
  static readonly vendorOrdersContact = '/api/vendor-orders/contact';
  static readonly vendorOrdersNoAcknowledge = '/api/vendor-orders/no-acknowledge';
  static readonly vendorOrdersSendMessage = '/api/vendor-orders/send-message';
  static readonly vendorOrdersMarkMessagesAsRead = '/api/vendor-orders/markMessagesAsRead';
  static readonly vendorOrdersCancelNew = '/api/vendor-orders/cancel/new';
  static readonly vendorOrdersJobDetail = '/api/vendor-orders/jobDetail/new';
  static readonly vendorOrdersCancelledEstimations = '/api/vendor-orders/jobDetail/new/cancelledEstimations';
  static readonly contactAzt = '/api/contact-azt';
  static readonly freeTextFeedback = '/api/feedback/free-text';
  static readonly documentFeedback = '/api/feedback/document';
  static readonly estimateReportBreakdown = '/api/breakdown';
  static readonly getVendorDetails = '/api/getVendorDetails';
  static readonly vendorsAvailable = '/api/vendors/available';
  static readonly preSignedUrl = '/api/presigned-url';
  static readonly checkFileExistsS3 = '/api/check-file-exists';
  static readonly sendSuggestion = '/api/feedback/user-satisfaction';
  static readonly getRecentLanguages = '/api/getRecent';
  static readonly getFolderFiles = '/api/get-folder-files';
  static readonly xtmCostBreakdown = '/api/xtm-breakdown';
}

export class LambdaEndPoints {
  static readonly translateFreeText = '/translate/text';
  static readonly translateDetect = '/translate/detect';
  static readonly translateDictionary = '/translate/dictionary';
  static readonly adminConfig = "/admin/configuration/";
  static readonly adminProviders = "/admin/providers/";
  static readonly adminServiceRequests = "ngs/service-request/list-by-status";
  static readonly newMessagesCount = '/messages/new/count';
}